<template>
  <div>
    <el-dialog
      id="editDialog"
      :title="orderId ? '修改采购单' : '新增采购单'"
      :visible="true"
      @close="close(false)"
      width="1000px"
    >
      <el-form
        :model="headInfo"
        label-position="right"
        label-width="100px"
        ref="editOrderFormRef"
        :rules="getRules"
        v-if="headInfo"
      >
        <el-form-item label="单号" v-if="headInfo.id">
          <span v-fmtype="headInfo.orderNo ? null : 'info'">{{
            headInfo.orderNo || "草稿"
          }}</span>
          <el-tag
            class="fm-ml-5"
            :type="
              $jsTool.getOrderApprovalStatusType(
                headInfo.orderApprovalStatusEnum
              )
            "
            >{{ headInfo.orderApprovalStatusEnum.Desc }}</el-tag
          >
        </el-form-item>
        <el-form-item label="单据日期" prop="orderDate">
          <el-date-picker
            v-model="headInfo.orderDate"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择单据日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="供应商" prop="supplierId">
          <SupplierSelect
            :value="supplier"
            @select="selectSupplier"
          ></SupplierSelect>
        </el-form-item>

        <el-form-item label="所选商品" prop="totalQuantity">
          <div class="fm-flex">
            <p
              v-fmtype="'success'"
              v-if="headInfo.totalQuantity && headInfo.totalQuantity > 0"
            >
              {{ "共 " + headInfo.totalQuantity + " 件商品" }}
            </p>
            <span v-fmtype="'error'" v-else>未选择商品</span>
            <span>，总采购价：</span>
            <FmAmount :amount="headInfo.commodityRetailTotalAmount"></FmAmount>
            <el-button
              class="fm-ml-15"
              type="primary"
              plain
              size="mini"
              icon="el-icon-plus"
              @click="showSelectCommodityDialog"
              >选择商品</el-button
            >
          </div>
        </el-form-item>
        <el-table
          :data="itemList || []"
          stripe
          :row-key="
            (row) => {
              return row.itemNo + row.commoditySpecId;
            }
          "
          max-height="500px"
          :span-method="objectSpanMethod"
          style="width: 100%"
        >
          <el-table-column
            label="商品图片"
            width="100"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityImage
                :commodity="scope.row.commodity"
                v-if="scope.row.saleSuitId"
              ></CommodityImage>
              <CommodityImage
                :commodity="scope.row.commodity"
                :commoditySpec="scope.row.commoditySpec"
                v-else
              ></CommodityImage>
            </template>
          </el-table-column>
          <el-table-column
            prop="saleSuitName"
            label="套装 / 商品信息"
            min-width="250"
            align="left"
            header-align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div style="line-height: 1.4em">
                <div style="font-size: 1.1em">
                  {{ scope.row.commodity.name }}
                </div>
                <div style="font-size: 1.1em" v-if="scope.row.saleSuitId">
                  {{ "套装名称：" + scope.row.saleSuitName }}
                </div>
                <div class="fm-mt-5">
                  {{ "分类：" + scope.row.commodity.commodityCategory.name }}
                </div>
                <div>{{ "颜色：" + scope.row.commodity.color }}<br /></div>
                <div>{{ "单位：" + scope.row.commodity.unit }}<br /></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="commoditySpec.specName"
            label="套装内容/规格名称"
            min-width="180"
            align="left"
            header-align="center"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.saleSuitId">
                <div
                  v-for="(item, index) in itemList
                    .filter(
                      (d) =>
                        d.saleSuitId && d.saleSuitId == scope.row.saleSuitId
                    )
                    .map(
                      (f) =>
                        f.commoditySpec.specName +
                        ' x ' +
                        f.saleSuitItemQuantity
                    )"
                  :key="index"
                >
                  {{ item }}
                </div>
                <div class="fm-flex">
                  套装内规格采购价：<FmAmount
                    :amount="
                      $jsTool.sum(
                        itemList
                          .filter(
                            (d) =>
                              d.saleSuitId &&
                              d.saleSuitId == scope.row.saleSuitId
                          )
                          .map((d) => d.commoditySpec.retailPrice)
                      )
                    "
                  ></FmAmount>
                </div>
              </div>
              <div class="fm-line-3" v-else>
                {{ scope.row.commoditySpec.specName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="retailPrice"
            label="套装/规格采购价"
            width="180"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.retailPrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
                v-if="!scope.row.saleSuitId"
              ></el-input-number>
              <el-input-number
                style="width: 170px"
                v-model="scope.row.saleSuitRetailPrice"
                size="small"
                :precision="2"
                :min="0"
                :step="1"
                @change="changeItemPrice(scope.$index, scope.row)"
                v-else
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemQuantity"
            label="采购数量"
            width="150"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <CommodityQuantityInputBox
                :key="
                  'itemQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.itemQuantity"
                size="small"
                :max="1000"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
                v-if="!scope.row.saleSuitId"
              ></CommodityQuantityInputBox>
              <CommodityQuantityInputBox
                :key="
                  'saleSuitQuantityInputNumber' + scope.$index + itemQuantityKey
                "
                :value="scope.row.saleSuitQuantity"
                size="small"
                @change="
                  (e) => {
                    changeItemQuantity(scope.$index, scope.row, e);
                  }
                "
                v-else
              ></CommodityQuantityInputBox>
            </template>
          </el-table-column>
          <el-table-column
            prop="commodityRetailTotalAmount"
            label="总采购价"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="
                  scope.row.saleSuitId
                    ? scope.row.saleSuitSumAmount
                    : scope.row.commodityRetailTotalAmount
                "
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="disCountAmount"
            label="折扣金额"
            width="120"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <FmAmount
                :amount="
                  scope.row.saleSuitId
                    ? scope.row.saleSuitDisCountAmount
                    : scope.row.disCountAmount
                "
              ></FmAmount>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemAmount"
            label="成交价"
            width="200"
            align="center"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-input-number
                style="width: 170px"
                v-model="scope.row.itemAmount"
                size="small"
                :precision="2"
                :max="
                  typeof scope.row.commodityRetailTotalAmount == 'string'
                    ? Number(scope.row.commodityRetailTotalAmount)
                    : scope.row.commodityRetailTotalAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
                v-if="!scope.row.saleSuitId"
              ></el-input-number>
              <el-input-number
                style="width: 170px"
                v-model="scope.row.saleSuitAmount"
                size="small"
                :precision="2"
                :max="
                  typeof scope.row.saleSuitSumAmount == 'string'
                    ? Number(scope.row.saleSuitSumAmount)
                    : scope.row.saleSuitSumAmount
                "
                :step="1"
                @change="changeItemAmount(scope.$index, scope.row)"
                v-else
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>

        <el-form-item label="优惠金额" prop="disCountAmount">
          <div class="fm-flex">
            <FmAmount :amount="headInfo.disCountAmount"></FmAmount>
            <span>（套装优惠金额：</span>
            <FmAmount
              :amount="
                $jsTool.sum(
                  $jsTool
                    .groupByV(
                      itemList.filter((d) => d.saleSuitId) || [],
                      'saleSuitId'
                    )
                    .map((d) =>
                      $jsTool.sub(
                        $jsTool.sum(d.map((d) => d.commodityRetailTotalAmount)),
                        d[0].saleSuitAmount
                      )
                    )
                )
              "
            ></FmAmount>
            <span>，规格优惠金额：</span>
            <FmAmount
              :amount="
                $jsTool.sum(
                  itemList
                    .filter((d) => !d.saleSuitId)
                    .map((f) => f.disCountAmount)
                )
              "
            ></FmAmount>
            <span>）</span>
          </div>
        </el-form-item>
        <el-form-item label="单据金额" prop="orderAmount">
          <el-input-number
            v-model="headInfo.orderAmount"
            size="small"
            :precision="2"
            :min="0"
            :max="
              typeof headInfo.commodityRetailTotalAmount == 'string'
                ? Number(headInfo.commodityRetailTotalAmount)
                : headInfo.commodityRetailTotalAmount
            "
            :step="1"
            style="width: 180px"
            @change="changeOrderAmount"
          ></el-input-number>
        </el-form-item>
        <div v-if="headInfo.extFieldValueAddNewPojoList.length > 0">
          <div style="height: 10px"></div>
          <el-divider content-position="left">
            <span style="font-weight: bold">拓展字段</span>
          </el-divider>
          <div style="height: 20px"></div>
          <el-row
            v-for="(rowItem, rowFiIndex) in $jsTool.groupArray(
              headInfo.extFieldValueAddNewPojoList,
              3
            )"
            :key="rowFiIndex"
          >
            <el-col :span="8" v-for="(item, fiIndex) in rowItem" :key="fiIndex">
              <el-form-item
                :class="item.visible ? '' : 'deleteFormItem'"
                :label="item.label"
                :required="item.requiredMark && item.visible"
                style="margin-bottom: 10px"
              >
                <span
                  style="color: var(--fm-warning-color)"
                  v-if="!item.visible"
                  >已删除</span
                >
                <template v-else>
                  <template v-if="item.extFieldTypeEnum == 'Input'">
                    <el-input
                      type="text"
                      :placeholder="item.configObj.placeholder"
                      :maxlength="item.configObj.maxlength"
                      v-model="item.value"
                      show-word-limit
                      style="width: 200px"
                    >
                    </el-input>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'InputNumber'">
                    <el-input-number
                      inputWidth="100"
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                      :max="item.configObj.max"
                      :min="item.configObj.min"
                      :step="item.configObj.step"
                      :precision="item.configObj.precision"
                      style="width: 200px"
                    ></el-input-number>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Radio'">
                    <el-radio-group v-model="item.value">
                      <el-radio
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                        style="
                          height: 32px;
                          align-content: space-around;
                          width: 200px;
                        "
                      ></el-radio>
                    </el-radio-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Checkbox'">
                    <el-checkbox-group v-model="item.value">
                      <el-checkbox
                        v-for="(check, index) in item.configObj.list"
                        :key="index"
                        :label="check.label"
                        :name="check.label"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'Select'">
                    <el-select
                      v-model="item.value"
                      :placeholder="item.configObj.placeholder"
                    >
                      <el-option
                        v-for="option in item.configObj.list"
                        :key="option.no"
                        :label="option.label"
                        :value="option.label"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-if="item.extFieldTypeEnum == 'TimePicker'">
                    <el-date-picker
                      v-model="item.value"
                      :type="item.configObj.format"
                      :value-format="
                        item.configObj.format == 'datetime'
                          ? 'yyyy-MM-dd HH:mm:ss'
                          : 'yyyy-MM-dd'
                      "
                      style="width: 200px"
                    >
                    </el-date-picker>
                  </template>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
        </div>

        <el-form-item label="业务员" prop="saleUserIdList">
          <UserTransfer
            v-model="headInfo.saleUserIdList"
            :userList="saleUserList"
            @addUser="addSaleUser"
            @cancelUser="cancelSaleUser"
          ></UserTransfer>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            maxlength="200"
            show-word-limit
            v-model="headInfo.remark"
            style="width: 400px"
            placeholder="请输入备注信息"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="close(false)">取 消</el-button>
        <el-button type="primary" @click="edit(false)"> 保存至草稿 </el-button>
        <el-popconfirm
          icon="el-icon-info"
          :icon-color="$jsTool.getColor('warning')"
          :title="
            orderConfig.needApproval
              ? '是否将单据提交审批？'
              : '当前单据提交后将自动审批通过，请确认单据信息无误，是否继续提交？'
          "
          @confirm="edit(true)"
        >
          <el-button slot="reference" type="success" @click.native.stop>
            保存并提交
          </el-button>
        </el-popconfirm>
      </div>
    </el-dialog>

    <CommoditySelectDialog
      :show="commoditySelectDialogShow"
      from="PurchaseOrder"
      :supplierId="supplier.id"
      :selectList="itemList"
      @selectCommodity="selectCommodity"
      @close="commoditySelectDialogShow = false"
      v-if="commoditySelectDialogShow"
    ></CommoditySelectDialog>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebPurchaseOrderEditDialog",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: null,
    },
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          setTimeout(async () => {
            Object.assign(this.$data, this.$options.data());
            this.$nextTick(() => {
              this.$refs.editOrderFormRef.clearValidate();
            });
            await this.getExtFieldList();
            this.initOrderData();
            this.getOrderConfig();
            this.quantityMinLimit = this.$jsTool.getTenantDecimalLength();
            if (this.orderId) {
              setTimeout(async () => {
                await this.getOrderInfo();
                this.$nextTick(() => {
                  this.$refs.editOrderFormRef.clearValidate();
                });
              }, 100);
            }
          }, 100);
        }
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.clearValidate();
        });
      },
      immediate: true,
    },
    // orderId: {
    //   handler(newVal) {
    //     if (newVal) {
    //       setTimeout(() => {
    //         this.getOrderInfo();
    //       }, 100);
    //     }
    //   },
    //   immediate: true,
    // },
  },
  computed: {
    getRules() {
      let res = {
        orderDate: this.$ruleUtil.simple({
          fieldName: "单据日期",
          handleType: "选择",
          required: true,
        }),
        supplierId: this.$ruleUtil.simple({
          fieldName: "供应商",
          handleType: "选择",
          required: true,
        }),
        orderAmount: this.$ruleUtil.number("单据金额", 0),
        totalQuantity: this.$ruleUtil.quantity(
          "商品",
          this.quantityMinLimit,
          1000
        ),
        saleUserIdList: this.$ruleUtil.array("业务员", "选择", 1),
      };
      return res;
    },
  },
  data() {
    return {
      orderConfig: {
        needApproval: true,
      },

      orderDatePickerShow: false,
      editItemPopupShow: false,
      editItem: {},

      id: null,
      headInfo: {
        orderApprovalStatusEnum: {},
        orderDate: null,
        supplierId: null,
        saleUserIdList: [],
        commodityRetailTotalAmount: "0.00",
        disCountAmount: "0.00",
        orderAmount: "0.00",
        totalQuantity: 0,
        remark: "",
        extFieldValueAddNewPojoList: [],
      },
      itemList: [],

      supplier: {},
      saleUserList: [],

      commoditySelectDialogShow: false,
      itemQuantityKey: "null",

      quantityMinLimit: 0.001,

      // 拓展字段
      extFieldList: [],
    };
  },

  mounted() {},

  methods: {
    async getExtFieldList() {
      let res = await this.$api.extField_findAvailableList("PurchaseOrder");
      if (res && res.success) {
        this.extFieldList = this.$jsTool.handleExtFiledRes(res.data);
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        (columnIndex == 0 ||
          columnIndex == 1 ||
          columnIndex == 2 ||
          columnIndex == 3 ||
          columnIndex == 4 ||
          columnIndex == 5 ||
          columnIndex == 6 ||
          columnIndex == 7) &&
        row.saleSuitId
      ) {
        let list = this.itemList
          .filter((d) => d.saleSuitId && d.saleSuitId == row.saleSuitId)
          .sort((a, b) => {
            return a.itemNo - b.itemNo;
          });
        if (list[0].itemNo == row.itemNo) {
          return {
            rowspan: list.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },

    selectSupplier(item) {
      this.headInfo.supplierId = item.id;
      this.supplier = item;
      this.itemList = [];
      this.selectCommodity(this.itemList);
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("supplierId");
      });
    },

    // 选择商品相关
    showSelectCommodityDialog() {
      if (!this.supplier || !this.supplier.id) {
        this.$message({
          message: "请先选择供应商",
          type: "error",
        });
        return;
      }
      this.commoditySelectDialogShow = true;
    },
    selectCommodity(list) {
      list.forEach((item, index) => {
        item.itemNo = index + 1; // 索引从 0 开始，所以 itemNo 从 1 开始
      });
      this.itemList = list;
      // 带销售套装的分组计算，避免重复
      let orderAmount = "0.00";
      let saleSuitList = list.filter((d) => d.saleSuitId);
      if (saleSuitList && saleSuitList.length > 0) {
        let groupRes = this.$jsTool.groupByV(saleSuitList, "saleSuitId");
        orderAmount = this.$jsTool.sum(
          groupRes.map((d) => d[0].saleSuitAmount)
        );
      }
      let specList = list.filter((d) => !d.saleSuitId);
      if (specList && specList.length > 0) {
        orderAmount = this.$jsTool.add(
          orderAmount,
          this.$jsTool.sum(specList.map((d) => d.itemAmount))
        );
      }
      this.headInfo.commodityRetailTotalAmount = this.$jsTool.sum(
        list.map((d) => d.commodityRetailTotalAmount)
      );
      this.headInfo.orderAmount = orderAmount;
      this.headInfo.disCountAmount = this.$jsTool.sub(
        this.headInfo.commodityRetailTotalAmount,
        orderAmount
      );
      this.headInfo.totalQuantity = Number(
        this.$jsTool.sumQuantity(list.map((d) => d.itemQuantity))
      );
      this.$nextTick(() => {
        this.$refs.editOrderFormRef.validateField("totalQuantity");
      });
      this.commoditySelectDialogShow = false;
    },
    changeItemPrice(index, row) {
      if (row.saleSuitId) {
        let saleSuitSumAmount = this.$jsTool.multi(
          row.saleSuitRetailPrice,
          row.saleSuitQuantity
        );
        row = {
          ...row,
          saleSuitSumAmount: saleSuitSumAmount,
          saleSuitDisCountAmount: "0.00",
          saleSuitAmount: saleSuitSumAmount,
        };
      } else {
        let itemAmount = this.$jsTool.multi(row.retailPrice, row.itemQuantity);
        row = {
          ...row,
          commodityRetailTotalAmount: itemAmount,
          disCountAmount: 0,
          itemAmount: itemAmount,
        };
      }
      this.$nextTick(() => {
        this.changeItemAfterHandle(index, row);
      });
    },
    changeItemQuantity(index, row, value) {
      if (value == 0) {
        this.$confirm("是否移除所选商品?", "操作提醒", {
          confirmButtonText: "移除",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          closeOnHashChange: false,
        })
          .then(() => {
            if (row.saleSuitId) {
              let selectSpecList = this.itemList.filter(
                (d) => d.saleSuitId && d.saleSuitId == row.saleSuitId
              );
              selectSpecList.forEach((item, index) => {
                let selectIndex = this.itemList.findIndex(
                  (d) =>
                    d.saleSuitId &&
                    d.saleSuitId == item.saleSuitId &&
                    d.commoditySpecId == item.commoditySpec.id
                );
                this.itemList.splice(selectIndex, 1);
              });
            } else {
              this.itemList.splice(index, 1);
            }
            this.$nextTick(() => {
              this.changeItemAfterHandle(index);
            });
          })
          .catch(() => {
            if (row.saleSuitId) {
              row.saleSuitQuantity = 1;
            } else {
              row.itemQuantity = 1;
            }
            // this.changeItemQuantity(index, row, 1);
            this.itemQuantityKey = Math.random();
          });
      } else {
        if (row.saleSuitId) {
          // 仅修改row，点击保存后再应用到单据
          let saleSuitSumAmount = this.$jsTool.multi(
            row.saleSuitRetailPrice,
            value
          );
          row = {
            ...row,
            saleSuitQuantity: value,
            saleSuitSumAmount: saleSuitSumAmount,
            saleSuitDisCountAmount: "0.00",
            saleSuitAmount: saleSuitSumAmount,
          };
        } else {
          let itemAmount = this.$jsTool.multi(row.retailPrice, value);
          row = {
            ...row,
            itemQuantity: value,
            commodityRetailTotalAmount: itemAmount,
            disCountAmount: 0,
            itemAmount: itemAmount,
          };
        }
        this.$nextTick(() => {
          this.changeItemAfterHandle(index, row);
        });
      }
    },
    changeItemAmount(index, row) {
      if (row.saleSuitId) {
        row.saleSuitDisCountAmount = this.$jsTool.sub(
          row.saleSuitSumAmount,
          row.saleSuitAmount
        );
      } else {
        if (
          (row.itemAmount || Number(row.itemAmount) == 0) &&
          (row.commodityRetailTotalAmount ||
            Number(row.commodityRetailTotalAmount) == 0)
        ) {
          row.disCountAmount = this.$jsTool.sub(
            row.commodityRetailTotalAmount,
            row.itemAmount
          );
        } else {
          row.disCountAmount = "0.00";
        }
      }
      this.changeItemAfterHandle(index, row);
    },
    changeItemAfterHandle(index, row) {
      if (!row) {
        this.selectCommodity(this.itemList);
        return;
      }
      if (row.saleSuitId) {
        let value = row.saleSuitQuantity;
        let selectSpecList = this.itemList.filter(
          (d) => d.saleSuitId && d.saleSuitId == row.saleSuitId
        );
        let totalRetailPrice = this.$jsTool.multi(
          row.saleSuitRetailPrice,
          value
        );
        let totalRetailPriceD = this.$jsTool.sub(
          totalRetailPrice,
          row.saleSuitDisCountAmount
        );
        let totalRetailAmount = this.$jsTool.sum(
          selectSpecList.map((d) =>
            this.$jsTool.multi(
              d.retailPrice,
              this.$jsTool.multi(d.saleSuitItemQuantity, value)
            )
          )
        );
        selectSpecList.forEach((item, i) => {
          let selectIndex = this.itemList.findIndex(
            (d) =>
              d.saleSuitId &&
              d.saleSuitId == item.saleSuitId &&
              d.commoditySpecId == item.commoditySpecId
          );
          let itemQuantity = Number(
            this.$jsTool.multi(value, item.saleSuitItemQuantity)
          );
          let itemTotalRetailAmount = this.$jsTool.multi(
            item.retailPrice,
            itemQuantity
          );
          let itemAmount = 0;
          if (i == selectSpecList.length - 1) {
            itemAmount = this.$jsTool.sub(
              totalRetailPriceD,
              this.$jsTool.sum(
                this.itemList
                  .filter(
                    (d) =>
                      d.saleSuitId &&
                      d.saleSuitId == row.saleSuitId &&
                      d.commoditySpecId != item.commoditySpecId
                  )
                  .map((f) => f.itemAmount)
              )
            );
          } else {
            itemAmount =
              Number(totalRetailAmount) == "0"
                ? "0.00"
                : this.$jsTool.multi(
                    itemTotalRetailAmount,
                    this.$jsTool.divis(totalRetailPriceD, totalRetailAmount, 8)
                  );
          }
          this.itemList.splice(selectIndex, 1, {
            ...this.itemList[selectIndex],
            saleSuitQuantity: value,
            saleSuitSumAmount: totalRetailPrice,
            saleSuitDisCountAmount: row.saleSuitDisCountAmount,
            saleSuitAmount: totalRetailPriceD,
            itemQuantity: itemQuantity,
            commodityRetailTotalAmount: itemTotalRetailAmount,
            disCountAmount: this.$jsTool.sub(itemTotalRetailAmount, itemAmount),
            itemAmount: itemAmount,
            saleSuitRetailPrice: row.saleSuitRetailPrice,
          });
        });
        this.selectCommodity(this.itemList);
      } else if (row.commoditySpecId) {
        this.itemList.splice(index, 1, row);
        this.selectCommodity(this.itemList);
      }
    },

    async initOrderData() {
      let userInfo = await this.$storageUtil.getUserInfo();
      this.headInfo.orderDate = this.$moment(new Date()).format("yyyy-MM-DD");
      this.headInfo.saleUserIdList = [userInfo.id];
      this.saleUserList = [userInfo];
      this.headInfo.extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(this.extFieldList || [])
      );
    },
    async getOrderConfig() {
      let res = await this.$api.tenantPersonalConfig_findByCodeIn([
        "Order:PurchaseOrder:NeedApproval",
      ]);
      if (res && res.success) {
        let needApprovalIndex = res.data.findIndex(
          (d) => d.code == "Order:PurchaseOrder:NeedApproval"
        );
        if (
          needApprovalIndex > -1 &&
          res.data[needApprovalIndex].value == "false"
        ) {
          this.orderConfig.needApproval = false;
        }
      }
    },
    async getOrderInfo(args) {
      let res = await this.$api.purchaseOrder_findVoById(this.orderId, {
        showLoading: true,
        loadingParam: {
          target: "#editDialog > *",
          lock: true,
        },
        ...args,
      });
      if (res && res.success) {
        this.headInfo = {
          ...res.data.head,
          saleUserIdList: res.data.head.saleUserList.map((d) => d.userId),
          extFieldValueAddNewPojoList: [],
        };

        let commodityIdList = res.data.itemList.map((d) => d.commodityId);
        let findCommodityVoRes = await this.$api.commodity_findVoByIdIn(
          commodityIdList,
          {
            showLoading: true,
            loadingParam: {
              target: "#editDialog > *",
              lock: true,
            },
          }
        );
        let commodityVoList = [];
        if (findCommodityVoRes && findCommodityVoRes.success) {
          commodityVoList = findCommodityVoRes.data;
        }

        this.itemList = res.data.itemList.map((d) => {
          let commodityVo = commodityVoList.filter(
            (f) => f.commodity.id == d.commodityId
          )[0];
          let item = d;
          item.commodity = commodityVo.commodity;
          item.commoditySpec = commodityVo.commoditySpecList.filter(
            (f) => f.id == d.commoditySpecId
          )[0];
          return item;
        });

        this.supplier = res.data.head.supplier;
        this.saleUserList = res.data.head.saleUserList.map((d) => d.user);

        // 拓展字段
        let extFieldValueAddNewPojoList = [];
        for (let extFieldItem of this.extFieldList) {
          let value = extFieldItem.value;
          if (
            res.data.head.extFieldValueList &&
            res.data.head.extFieldValueList.length > 0
          ) {
            let extFieldValueAddNewIndex =
              res.data.head.extFieldValueList.findIndex(
                (d) => d.code == extFieldItem.code
              );
            let extFieldValueAddNewItem =
              res.data.head.extFieldValueList[extFieldValueAddNewIndex];
            if (extFieldValueAddNewIndex > -1) {
              value =
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum.Name ||
                extFieldItem.extFieldTypeEnum ==
                  extFieldValueAddNewItem.extFieldTypeEnum
                  ? extFieldValueAddNewItem.value
                  : null;
              if (
                extFieldItem.extFieldTypeEnum == "Checkbox" ||
                extFieldItem.extFieldTypeEnum.Name == "Checkbox"
              ) {
                if (value) {
                  if (typeof value == "string") {
                    value = value.split(",");
                  }
                } else {
                  value = [];
                }
              }
            }
          }
          extFieldValueAddNewPojoList.push({
            ...JSON.parse(JSON.stringify(extFieldItem)),
            value: value,
          });
        }
        this.headInfo.extFieldValueAddNewPojoList = extFieldValueAddNewPojoList;
        this.$nextTick(() => {
          this.$refs.editOrderFormRef.clearValidate();
        });
      }
    },

    // 业务员
    addSaleUser(list) {
      this.saleUserList = this.saleUserList.concat(list);
    },
    cancelSaleUser(list) {
      let cancelIdList = list.map((d) => d.id);
      this.saleUserList = this.saleUserList.filter(
        (d) => !cancelIdList.some((f) => f == d.id)
      );
    },

    changeOrderAmount() {
      let that = this;
      this.headInfo = {
        ...this.headInfo,
        disCountAmount: this.$jsTool.sub(
          this.headInfo.commodityRetailTotalAmount,
          this.headInfo.orderAmount
        ),
      };
      let hasSaleSuitList = that.itemList.filter((d) => d.saleSuitId);
      let noSaleSuitList = that.itemList.filter((d) => !d.saleSuitId);
      // 先处理销售套装
      let radio =
        Number(that.headInfo.commodityRetailTotalAmount) == "0"
          ? 0
          : this.$jsTool.divis(
              that.headInfo.orderAmount,
              that.headInfo.commodityRetailTotalAmount,
              8
            );
      if (hasSaleSuitList && hasSaleSuitList.length > 0) {
        let hasSaleSuitArr = this.$jsTool.groupByV(
          hasSaleSuitList,
          "saleSuitId"
        );
        hasSaleSuitArr.forEach((saleSuitItem, saleSuitIndex) => {
          let saleSuitAmount = 0;
          if (
            saleSuitIndex == hasSaleSuitArr.length - 1 &&
            (!noSaleSuitList || noSaleSuitList.length == 0)
          ) {
            saleSuitAmount = that.$jsTool.sub(
              that.headInfo.orderAmount,
              that.$jsTool.sum(
                that.$jsTool
                  .groupByV(
                    that.itemList.filter(
                      (d) =>
                        d.saleSuitId &&
                        d.saleSuitId != saleSuitItem[0].saleSuitId
                    ),
                    "saleSuitId"
                  )
                  .map((d) => d[0].saleSuitAmount)
              )
            );
          } else {
            saleSuitAmount = that.$jsTool.multi(
              radio,
              saleSuitItem[0].saleSuitSumAmount
            );
          }

          saleSuitItem.forEach((item, index) => {
            let curIndex = that.itemList.findIndex(
              (d) =>
                d.saleSuitId &&
                d.saleSuitId == item.saleSuitId &&
                d.commoditySpecId == item.commoditySpecId
            );
            let itemAmount = 0;
            if (index == saleSuitItem.length - 1) {
              itemAmount = that.$jsTool.sub(
                saleSuitAmount,
                that.$jsTool.sum(
                  that.itemList
                    .filter(
                      (d) =>
                        d.saleSuitId &&
                        d.saleSuitId == saleSuitItem[0].saleSuitId &&
                        d.commoditySpecId != item.commoditySpecId
                    )
                    .map((f) => f.itemAmount)
                )
              );
            } else {
              itemAmount = that.$jsTool.multi(
                radio,
                item.commodityRetailTotalAmount
              );
            }

            that.itemList.splice(curIndex, 1, {
              ...that.itemList[curIndex],
              saleSuitAmount: saleSuitAmount,
              saleSuitDisCountAmount: that.$jsTool.sub(
                item.saleSuitSumAmount,
                saleSuitAmount
              ),
              itemAmount: itemAmount,
              disCountAmount: that.$jsTool.sub(
                item.commodityRetailTotalAmount,
                itemAmount
              ),
            });
          });
        });
      }

      if (noSaleSuitList && noSaleSuitList.length > 0) {
        noSaleSuitList.forEach((item, index) => {
          let curIndex = that.itemList.findIndex(
            (d) => !d.saleSuitId && d.commoditySpecId == item.commoditySpecId
          );
          let itemAmount = 0;
          if (index == noSaleSuitList.length - 1) {
            itemAmount = that.$jsTool.sub(
              that.headInfo.orderAmount,
              that.$jsTool.sum(
                that.itemList
                  .filter(
                    (d) =>
                      d.saleSuitId ||
                      (!d.saleSuitId &&
                        d.commoditySpecId != item.commoditySpecId)
                  )
                  .map((f) => f.itemAmount)
              )
            );
          } else {
            itemAmount = that.$jsTool.multi(
              radio,
              item.commodityRetailTotalAmount
            );
          }
          that.itemList.splice(curIndex, 1, {
            ...that.itemList[curIndex],
            itemAmount: itemAmount,
            disCountAmount: that.$jsTool.sub(
              item.commodityRetailTotalAmount,
              itemAmount
            ),
          });
        });
      }

      this.selectCommodity(this.itemList);
    },
    edit(submit) {
      //  校验拓展字段是否填写
      for (let item of this.headInfo.extFieldValueAddNewPojoList) {
        if (item.requiredMark && item.visible && item.value == null) {
          this.$message({
            message: "请完善拓展字段 " + item.label,
            type: "error",
          });
          return;
        }
      }
      let extFieldValueAddNewPojoList = JSON.parse(
        JSON.stringify(
          this.headInfo.extFieldValueAddNewPojoList.filter((d) => d.visible)
        )
      );
      for (let item of extFieldValueAddNewPojoList) {
        if (item.extFieldTypeEnum == "Checkbox" && item.value) {
          item.value = item.value.toString();
        }
        item.extFieldId = item.id;
      }
      this.$refs.editOrderFormRef.validate(async (valid) => {
        if (!valid) {
          return;
        }
        let requestRes = this.headInfo.id
          ? submit
            ? await this.$api.purchaseOrder_updateAndSubmit(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
            : await this.$api.purchaseOrder_update(
                {
                  headUpdatePojo: {
                    ...this.headInfo,
                    extFieldValueAddNewPojoList,
                  },
                  itemAddNewPojoList: this.itemList,
                },
                {
                  showLoading: true,
                  loadingParam: {
                    target: "#editDialog > *",
                    lock: true,
                    text: "修改中...",
                  },
                }
              )
          : submit
          ? await this.$api.purchaseOrder_saveIntoDraftAndSubmit(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            )
          : await this.$api.purchaseOrder_saveIntoDraft(
              {
                headAddNewPojo: {
                  ...this.headInfo,
                  extFieldValueAddNewPojoList,
                },
                itemAddNewPojoList: this.itemList,
              },
              {
                showLoading: true,
                loadingParam: {
                  target: "#editDialog > *",
                  lock: true,
                  text: "新增中...",
                },
              }
            );
        if (requestRes && requestRes.success) {
          this.close(true);
        }
      });
    },
    close(flush) {
      this.$emit("close", flush);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/order/PurchaseOrderEditDialog.vue